import Base from './base';

export default {
  getById: async (productId: number): Promise<any> => (await Base()).get(`/products/${productId}`),
  getList: async (limit?: number, page?: number): Promise<any> => {
    const url = `products/?${limit ? `limit=${limit}` : ''}${page ? `&page=${page}` : ''}`;
    return (await Base()).get(url);
  },
};
